import axios from '@/plugins/axios'

export function getAreas(params = {}) {
    return axios.get('area', {
        params,
    })
}

export function indexAreas(params = {}) {
    return axios.get('index/areaList', {
        params,
    })
}

export function getMerchant(params = {}) {
    return axios.get('index/merchantList', {
        params,
    })
}

export function showArea(id) {
    return axios.get(`area/${id}`)
}

export function storeArea(data) {
  return axios.post('area', data)
}

export function updateArea(id, data) {
  return axios.put(`area/${id}`, data)
}

export function editArea(id) {
  return axios.get(`area/${id}/edit`)
}

export function destroyArea(id) {
  return axios.delete(`area/${id}`)
}

export function getMainAreas(params = {}) {
    return axios.get("area-main", {
        params,
    });
}
export function getCloneAreasList() {
    return axios.get("area-select-options");
}
